import siteRole from './siteRole'
import permissionRole from './permissionRole'
import batch from './batch'
import customer from './customer'
import customerRank from './customerRank'
import upload from './upload'
import download from './download'
import log from './log'
import order from './order'
import orderDetail from './orderDetail'
import point from './point'
import pointSetting from './pointSetting'
import account from './account'
import product from './product'
import productDetail from './productDetail'
import stockAlert from './stockAlert'
import ecStock from './ecStock'
import masterColor from './masterColor'
import masterColorGroup from './masterColorGroup'
import masterSize from './masterSize'
import masterSizeGroup from './masterSizeGroup'
import orderQuantity from './orderQuantity'
import masterComponent from './masterComponent'
import masterLogisticsCalendar from './masterLogisticsCalendar'
import mailTemplate from './mailTemplate'

export default {
  siteRole: siteRole,
  permissionRole: permissionRole,
  batch: batch,
  customer: customer,
  customerRank: customerRank,
  upload: upload,
  download: download,
  log: log,
  order: order,
  orderDetail: orderDetail,
  point: point,
  pointSetting: pointSetting,
  account: account,
  product: product,
  productDetail: productDetail,
  stockAlert: stockAlert,
  ecStock: ecStock,
  masterColor: masterColor,
  masterColorGroup: masterColorGroup,
  masterSize: masterSize,
  masterSizeGroup: masterSizeGroup,
  orderQuantity: orderQuantity,
  masterComponent: masterComponent,
  masterLogisticsCalendar: masterLogisticsCalendar,
  mailTemplate: mailTemplate
}



// WEBPACK FOOTER //
// ./src/store/pages/index.js